export const DEFAULT_METHOD_TYPE = 'refer' as const;
export const DEFAULT_ENCRYPTION = 'TLS/SRTP' as const;
export const METHOD_TYPE_PREFIX = 'SIP';
